import React from 'react'
import { css } from '@emotion/css'

const iconSmallCss = css`
  width: 24px;
  height: 24px;
`
const iconLargeCss = css`
  width: 64px;
  height: 64px;
`
export const ImageIcon = ({ src, alt, size = 'small' }) => {
  return (
    <img
      src={src}
      alt={alt}
      className={size === 'small' ? iconSmallCss : iconLargeCss}
    />
  )
}
